import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloModaDonna } from '@/mocks/articles';

export default function ModaDonnaPage() {
  return <ArticleLayout article={articoloModaDonna} />;
}